
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as admin18Emvyw_eCblxnHyl1amrd5DX49kSCUa48VCXzH2FHUMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin.vue?macro=true";
import { default as indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as profilecq9fZ17utFcrTLFZUCTB0Miv7ztpiKZkOr1NwVkJ1gsMeta } from "/opt/atlassian/pipelines/agent/build/pages/profile.vue?macro=true";
import { default as callbackN2brxAiORzWTJha6dlSyIzl3WhPueYsn26NnCizNhRwMeta } from "/opt/atlassian/pipelines/agent/build/layers/auth-stack-oidc/pages/oidc/callback.vue?macro=true";
import { default as developerrBL7plvZD6RRx2ewRpBnD375ogit0AVfZrEp_ZSbxDgMeta } from "/opt/atlassian/pipelines/agent/build/layers/auth-stack-oidc/pages/_oidc/developer.vue?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    meta: admin18Emvyw_eCblxnHyl1amrd5DX49kSCUa48VCXzH2FHUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profilecq9fZ17utFcrTLFZUCTB0Miv7ztpiKZkOr1NwVkJ1gsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/profile.vue")
  },
  {
    name: "oidc-callback",
    path: "/oidc/callback",
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/auth-stack-oidc/pages/oidc/callback.vue")
  },
  {
    name: "_oidc-developer",
    path: "/_oidc/developer",
    meta: developerrBL7plvZD6RRx2ewRpBnD375ogit0AVfZrEp_ZSbxDgMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/auth-stack-oidc/pages/_oidc/developer.vue")
  }
]